<div class="cupons">
  <h4 class="tit-secao">
    <svg class="i sm" viewBox="0 0 24 24"><path d="M3 9a2 2 0 0 0 0 6v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3a2 2 0 0 0 0-6V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1z" /><path d="M14 5v2M14 11v2M14 17v2" /></svg>
    Cupons disponíveis
    <span class="selo ok" *ngIf="total">{{ total }}</span>
  </h4>

  <p class="dica" *ngIf="carregando">Carregando cupons...</p>
  <p class="dica erro-cupom" *ngIf="!carregando && erro" role="alert">Não foi possível carregar os cupons.</p>
  <p class="cupons-vazio" *ngIf="!carregando && !erro && !cupons.length">Nenhum cupom disponível</p>

  <div class="lista-cupons" *ngIf="!carregando && cupons.length">
    <div class="cupom" *ngFor="let c of cupons; trackBy: trackCupom" [ngClass]="'cupom-' + c.tipo" [class.vencendo]="c.vencendo">
      <div class="cupom-valor">
        <b>{{ c.desconto }}</b>
        <small>{{ c.rotuloDesconto }}</small>
      </div>
      <div class="cupom-corpo">
        <div class="cupom-cod" [title]="c.codigo">
          {{ c.codigo }}
          <span class="cupom-qt" *ngIf="c.quantidade > 1">× {{ c.quantidade }}</span>
        </div>
        <div class="cupom-desc" *ngIf="c.descricao" [title]="c.descricao">{{ c.descricao }}</div>
        <div class="cupom-rodape">
          <span class="cupom-tipo">{{ c.rotuloTipo }}</span>
          <span class="cupom-validade">{{ c.validade }}</span>
        </div>
      </div>
    </div>
  </div>

  <p class="dica" *ngIf="!carregando && cupons.length">Só para consulta: o cupom é aplicado no pagamento da conta, não no agendamento.</p>
</div>
